import Partner2 from "../dao/Partner2";

const SustainChainPartners = () => {
  return (
    <>
      {/* <!-- Partners --> */}
      <section className="py-10 overflow-hidden dark:bg-jacarta-900">
        <div className="container">
          <div className="mx-auto mb-4 max-w-xl text-center">
            <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            SustainChain’s <span className="animate-gradient"> Partners</span>
            </h2>
            {/* <p className="text-lg dark:text-jacarta-300">
              Impact DOTs can be used to represent items such as photos, videos, audio,
              and other types of digital files.
            </p> */}
          </div>
        </div>
        <div className="mb-8 flex animate-marqueeRight space-x-8">
          <Partner2 />
        </div>
        {/* End .animate-marqueeRight */}

        {/* <div className="flex animate-marquee space-x-8">
          <Partner2 />
        </div> */}
        {/* animate-marquee */}
      </section>
      {/* <!-- end partners -->  */}
    </>
  );
};

export default SustainChainPartners;
